import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  PasswordInput,
  required,
  minLength,
  maxLength,
} from 'react-admin';
import { passwordValidator } from '../../utils/passwordValidation';

const validateUsername = [required(), minLength(3), maxLength(50)];
const validatePassword = [required(), passwordValidator];
const validateRole = [required()];

export const UserCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="username" validate={validateUsername} fullWidth />
      <PasswordInput
        source="password"
        validate={validatePassword}
        fullWidth
        helperText="At least 8 characters, with uppercase, lowercase, number and special character"
      />
      <SelectInput
        source="role"
        validate={validateRole}
        choices={[
          { id: 'Admin', name: 'Admin' },
          { id: 'Partner', name: 'Partner' },
        ]}
        defaultValue="Partner"
        fullWidth
      />
      <ReferenceInput source="groupId" reference="groups" label="Group">
        <SelectInput optionText="name" emptyText="No Group" fullWidth />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
